import { openBlock as l, createElementBlock as o, createElementVNode as e } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, c = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M9.75 6a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0ZM8 5.75a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5Z",
  "clip-rule": "evenodd"
}, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M7.721 1.304a.75.75 0 0 1 .558 0l5 2A.75.75 0 0 1 13.75 4v6c0 .066-.009.13-.025.194-.31 1.156-1.19 2.122-2.18 2.857-1.003.746-2.208 1.32-3.324 1.666a.752.752 0 0 1-.442 0c-1.116-.345-2.321-.92-3.325-1.666-.989-.735-1.869-1.701-2.178-2.857A.75.75 0 0 1 2.25 10V4a.75.75 0 0 1 .471-.696l5-2ZM3.75 4.508v5.386c.104.33.297.664.567.993.147-.67.532-1.273 1.082-1.73C6.108 8.564 7.045 8.25 8 8.25c.955 0 1.892.315 2.601.906.55.458.935 1.062 1.082 1.731.27-.329.463-.663.567-.993V4.508L8 2.808l-4.25 1.7Zm6.51 7.612a.758.758 0 0 1-.01-.12v-.5c0-.415-.197-.848-.609-1.192C9.225 9.962 8.636 9.75 8 9.75c-.636 0-1.225.212-1.641.558-.412.344-.609.777-.609 1.192v.5c0 .04-.003.081-.01.12.702.46 1.497.835 2.26 1.092a10.065 10.065 0 0 0 2.26-1.092Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  c,
  n
];
function r(a, s) {
  return l(), o("svg", t, [...d]);
}
const v = { render: r };
export {
  v as default,
  r as render
};
